module.exports = __webpack_public_path__ + "img/image02.ffefeae4.jpg";